import BaseModel from './BaseModel';

export default class Battery extends BaseModel {
  constructor(public level: number) {
    super();
  }

  toString(): string {
    return `BatteryLevel: ${this.level}`;
  }

  toJSON() {
    return {
      level: this.level,
    };
  }
}
